export default __webpack_public_path__ + "static/media/arrow-bg.a9c555a3.svg";